import React from "react";
import { Row, Col } from "react-flexbox-grid";
// SCSS
import "./hero.scss";
//Assets
import HeroImage from '../../assets/hero/talha-anis.png';
//Components
import Button from '../ui-components/button/button';

const hero = () => (
  <div className="hero" id="hero">
    <div className="wrapper">
      <Row>
        <Col md={6} lg={12}>
          <div className="hero-image">
            <img src={HeroImage} alt="profile" />
          </div>
        </Col>
        <Col md={6} lg={12}>
          <div className="hero-info">
            <h1 className="font15">HEY THERE !</h1>
            <h1 className="font-info">
              I AM <span style={{ background: "yellow" }}>TALHA ANIS</span>
            </h1>
            <p className="font14">
              Founder of CodePy - A Software Development Company 
              <p className="font14">We build products that outperform.</p>
            </p>
            <Button label="SEND MESSAGE" target={"contact"} />
          </div>
        </Col>
      </Row>
    </div>
  </div>
);

export default hero;